<template>
	<div class="room-page">
		<div class="room-left-con">
			<div class="top" v-if="detailPageData.status !== 3 && detailPageData.status !== 4">
				<div v-if="(detailPageData.subStatus == 1 && detailPageData.status == 1) ||
					(detailPageData.subStatus == 1 &&
						(detailPageData.status == 5 || detailPageData.status == 6))
					">
					<img class="alarm-icon" src="./../../assets/img/Avatar@2x.png" alt="" />
				</div>
				<div v-else>
					<div v-if="detailPageData.statusName == '睡觉'">
						<img class="alarm-icon" src="./../../assets/img/AvatarSleep@2x.png" alt="" />
					</div>
					<div v-else>
						<img class="alarm-icon" v-if="stableNum >= 80" src="./../../assets/img/Avatar_people@2x.png" alt="" />
						<img class="alarm-icon" v-if="stableNum < 80 && stableNum >= 59" src="./../../assets/img/MediumMove-80.gif"
							alt="" />
						<img class="alarm-icon" v-if="stableNum < 59" src="./../../assets/img/FastMove-80.gif" alt="" />
					</div>
				</div>
				<div class="status">
					<div class="status-top">
						<div class="text" :class="{
							'text-alarm':
								detailPageData.statusName == '心跳过速' ||
								detailPageData.statusName == '心跳过缓' ||
								detailPageData.statusName == '呼吸过缓' ||
								detailPageData.statusName == '呼吸过速' ||
								detailPageData.statusName == '离床过久',
						}">
							{{ detailPageData.statusName }}
						</div>
						<div class="bar" v-if="monitorStatusStr == ''">
							数据载入中 {{ num }}s
						</div>
						<div class="bar" v-else>{{ monitorStatusStr }}</div>
					</div>
					<div class="stable" v-if="(detailPageData.subStatus !== 1 && detailPageData.status !== 1) ||
						(detailPageData.subStatus !== 1 &&
							(detailPageData.status !== 5 || detailPageData.status !== 6))
						">
						<div class="stable-alarm" :style="{
							width: stableNum < 20 ? 20 + '%' : stableNum + '%',
							background:
								'linear-gradient(270deg,' +
								endColor +
								' 0%,' +
								beginColor +
								' 100%)',
						}">
							{{ stableNum }}% 稳定
						</div>
					</div>
				</div>
			</div>
			<div class="room-left" v-show="!showEchars">
				<!-- 离床报警 -->
				<img class="alarm-icon" v-if="detailPageData.subStatus == 1 && detailPageData.hasAlarm == true
					" src="./../../assets/img/warning-circle-fill@2x.png" alt="" />
				<span class="leave-bed-alarm" v-if="detailPageData.subStatus == 1 &&
					detailPageData.hasAlarm == true &&
					duration != ''
					">已离床 {{ duration }}</span>
				<!-- 离床不报警 -->
				<span class="leave-bed-noalarm" v-if="detailPageData.subStatus == 1 &&
					detailPageData.status == 1 &&
					detailPageData.hasAlarm == false &&
					duration != ''
					">已离床 {{ duration }}</span>
				<span class="off-line" v-if="detailPageData.status == 3">离线</span>
				<span class="close" v-if="detailPageData.status == 4">监测仪已关闭</span>
			</div>
			<div class="echats-con" v-show="showEchars">
				<div ref="echartsForBreach" class="grid_line" style="width: 880px;height:145px;"></div>
				<div class="split-line"></div>
				<div class="heart-con">
					<div ref="echartsForHeart" class="grid_line" style="width: 880px;height:160px;"></div>
					<div v-if="showEchars" class="heart-circle" :style="{
						left: circlePosition,
						top: circleTopPosition,
						background: circleBackground,
					}"></div>
				</div>
			</div>
		</div>
		<div class="room-right">
			<div v-if="isShowGray === 1" class="room-right-con">
				<div class="switch">
					<div class="realTop_left">
						<div class="left_header">
							<span class="left_title">监测仪</span>
							<div style="position: relative; top:-2px" v-if="role == 3">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" style="top:5px" class="switch-btn-open">开</span>
								<span v-else style="top:5px" class="switch-btn-off">关</span>
							</div>
							<div style="position: relative;" v-else class="left_title title-flex">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
								<div class="title-flex-set" @click="setToitet">设置</div>
							</div>
						</div>
					</div>
				</div>
				<div class="room-icon">
					<div class="img_icon">
						<img src="./../../assets/img/breath_gary.png" alt="" />
						<div>--</div>
					</div>
					<div class="img_icon">
						<img src="./../../assets/img/heart_gary.png" alt="" />
						<div>--</div>
					</div>
				</div>
			</div>
			<div v-if="isShowGray === 2" class="room-right-con">
				<div class="switch">
					<div class="realTop_left">
						<div class="left_header">
							<span class="left_title">监测仪</span>
							<div style="position: relative;" v-if="role == 3">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
							</div>
							<div style="position: relative;" v-else class="left_title title-flex">
								<el-switch v-model="switchStatus" :width="40" class="switch" active-color="#1890FF"
									inactive-color="#79b5f6" @change="setStatus">
								</el-switch>
								<span v-if="switchStatus" class="switch-btn-open">开</span>
								<span v-else class="switch-btn-off">关</span>
								<div class="title-flex-set" @click="setToitet">设置</div>
							</div>
						</div>
					</div>
				</div>
				<div class="room-icon">
					<div class="room-icon-item">
						<div class="item-text item-lin" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p class="conter-low" :class="{ 'alarm-conter': isShowRedBreath == 1 }"></p>
							<p class="conter"></p>
							<p class="conter-height" :class="{ 'alarm-conter': isShowRedBreath == 3 }"></p>
							<div class="position-cirle" :class="{ 'alarm-conter': isShowRedBreath !== 2 }" :style="{
								left: breathPosition,
								background: isShowRedBreath !== 2 ? '#FF4D4F' : '#5CC726',
							}"></div>
						</div>
						<div class="item-text" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p :class="{ 'alarm-conter': isShowRedBreath == 1 }">偏低</p>
							<p :style="{
								color: isShowRedBreath == 2 ? '#5CC726' : '#262626',
							}">
								正常
							</p>
							<p :class="{ 'alarm-conter': isShowRedBreath == 3 }">偏高</p>
						</div>
						<div class="img_icon">
							<img v-if="isShowRedBreath == 2" src="./../../assets/img/breath_blue.png" alt="" />
							<img v-else src="./../../assets/img/breath_alarm@2x.png" alt="" />
							<div class="breath-text" :style="{ color: isShowRedBreath !== 2 ? '#FF4D4F' : '' }">
								{{ breathBPM }}
							</div>
						</div>
					</div>
					<div class="room-icon-item">
						<div class="item-text item-lin" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p class="conter-low" :class="{ 'alarm-conter': isShowRedHeart == 1 }"></p>
							<p class="conter"></p>
							<p class="conter-height" :class="{ 'alarm-conter': isShowRedHeart == 3 }"></p>
							<div class="position-cirle" :class="{ 'alarm-conter': isShowRedHeart !== 2 }" :style="{
								left: heartPosition,
								background: isShowRedHeart !== 2 ? '#FF4D4F' : '#5CC726',
							}"></div>
						</div>
						<div class="item-text" v-if="roomStatus == 1 || roomStatus == 5 || roomStatus == 6">
							<p :class="{ 'alarm-conter': isShowRedHeart == 1 }">偏低</p>
							<p :style="{
								color: isShowRedHeart == 2 ? '#5CC726' : '#262626',
							}">
								正常
							</p>
							<p :class="{ 'alarm-conter': isShowRedHeart == 3 }">偏高</p>
						</div>
						<div class="img_icon">
							<img v-if="isShowRedHeart == 2" src="./../../assets/img/heart_green.png" alt="" />
							<img v-else src="./../../assets/img/heart_alarm@2x.png" alt="" />
							<div class="heart-text" :style="{ color: isShowRedHeart !== 2 ? '#FF4D4F' : '' }">
								{{ heartBPM }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<a-modal title="设置" :width="400" :visible="editAbnormalTimePopupOutBed" :maskClosable="false" :footer="null"
				@cancel="editAbnormalTimeCancelOutBed">
				<div v-if="getFallLongTimeData.timePeriods && getFallLongTimeData.timePeriods.length > 0">
					<div class="titleTime mb10">监测时间段</div>
					<div class="picker" :key="index" v-for="(item, index) in getFallLongTimeData.timePeriods">
						<a-time-picker :allowClear="false" v-model="item.startTime" format="HH:mm"></a-time-picker>
						<img class="rJt" src="../../assets/rJt.png" alt="">
						<a-time-picker :allowClear="false" v-model="item.endTime" format="HH:mm"></a-time-picker>
					</div>
				</div>
				<div class="picker">
					<div class="titleTime">离床异常时长</div>
					<!-- 删除了 :disabled="OutBeddisabled" -->
					<a-time-picker :allowClear="false" v-model="editHandleTimeValOutBed" format="HH:mm:ss"></a-time-picker>
				</div>
				<div class="picker">
					<div class="titleTime">关联卫生间</div>
					<a-cascader :value="relateWC_treeData_value_Sel_Next" :default-value="relateWC_treeData_value"
						:options="relateWC_treeData" placeholder="点击选择需要关联的设备" @change="change_relateWC($event)" />
				</div>
				<div class="addBtn toitet-btn">
					<a-button style="margin-right: 10px" @click="editAbnormalTimeCancelOutBed">取消</a-button>
					<a-button type="primary" @click="editAbnormalTimeToitet">确定</a-button>
				</div>
			</a-modal>
		</div>
	</div>
</template>
<script>
import Stomp from 'stompjs';
import SockJS from 'sockjs-client';

import detaliPageConRoomCommonData1 from './detaliPageConRoomCommonData1.json'
import detaliPageConRoomCommonData2 from './detaliPageConRoomCommonData2.json'
import detaliPageConRoomCommonData3 from './detaliPageConRoomCommonData3.json'
import detaliPageConRoomCommonData4 from './detaliPageConRoomCommonData4.json'

import getEchartOptionDetaliPageConRoom1 from '../detaliPage/detaliPageConRoom1.js'
import getEchartOptionDetaliPageConRoom2 from '../detaliPage/detaliPageConRoom2.js'

export default {
	props: {
		detailPageData: {
			type: Object,
			default: () => { },
		},
	},
	data() {
		return {
			getFallLongTimeData: '',
			OutBeddisabled: false,
			isOutBed: 0,
			role: 2,
			heartBPM: '--',
			breathBPM: '--',
			switchStatus: true,
			isShowGray: 2,
			duration: '',
			socketStatus: null,
			stompClientStatus: null,
			reconInv: null,
			breathXdata: [],
			breathYdata: [],
			breathYdataCopy: [],
			breathInterval: null,
			heartXdata: [],
			heartYdata: [],
			heartYdataCopy: [],
			heartInterval: null,
			replaceArr: [],
			circlePosition: '0%',
			circleTopPosition: '0px',
			circleBackground: '#53c31b',
			breathPosition: '0%',
			heartPosition: '0%',
			isShowRedHeart: 2,
			isShowRedBreath: 2,
			roomStatus: 1,
			isShowEchars: false,
			num: 10,
			intervalPulsSecond: null,
			secondNum: 0,
			stableNum: 100,
			monitorStatusStr: '',
			beginColor: '#DA9D0B',
			endColor: '#65E332',
			socketStatusEchars: null,
			stompClientStatusEchars: null,
			reconInvEcahrs: null,
			showEchars: false,
			leaveBedInterval: null,
			heartflag: 0,

			// 模拟呼吸波形
			Buff_BreathWave_Y_Flt: [0, 0, 0, 0, 0],
			Phi: 0,
			BreathWave_A: 5,
			// 模拟心跳波形
			Buff_Electrocardiogram_QRST: detaliPageConRoomCommonData2, // 100Hz QRST波模型
			Buff_Electrocardiogram_PR: detaliPageConRoomCommonData3, // 100Hz PR波模型
			HeartWave_QRSTPR_cnt: 66, // QRSTPR波对应的时间（毫秒）
			T_cnt_present: -1, // 当前正在绘制的图形的周期点数
			pointer: 0, // 当前从心跳模型中打点的位置
			HeartWave_Y_Mode: [0], // 心跳波形模型初始化
			Counter: 5,
			CounterInterval: null,
			drawInterval: null,
			myChartHeart: null,
			myChartBreath: null,
			changeHeartDataInterval: null,
			heartAllLineData: [],
			isBeginDrawechars: false,
			bedSetId: '', // 离床报警设置设备id
			radarId: '', // 离床报警设置设备id
			editHandleTimeValOutBed: '', // 离床时长异常时间值
			editAbnormalTimePopupOutBed: false,
			// 关联卫生间树形结构部分
			relateWC_treeData: [],
			relateWC_treeData_value: [], //当前值,为进入查看时的值
			relateWC_treeData_value_Sel_Prev: [], //选中前的值
			relateWC_treeData_value_Sel_Next: [], //选中后的值



			// 画线 Websocket
			stompClient: null,
			socket: null,
			timer: null,
			start1: null,

			// 状态 Websocket
			statusStompClient: null,
			statusSocket: null,
			statusTimer: null,
			start2: null,

			// 定时器 - 创造数据
			interval: null,
			intervalCount: 0,

			// 定时器 - 离床时长
			durationTimer: null,

			// WebSocket 传输过来的数据
			websocketData: null,

			/**
				 * WebSocket相关内容
				 */
			// 呼吸率 & 心率 相关
			sockFlagNum: 0,
			// 呼吸率相关
			breathBpm: 15,
			breathDatas: [],
			paintBreathDatas: [],
			paintBreathDatasCurrentIndex: 0,
			Phi: 0,
			Buff_BreathWave_Y_Flt: [0, 0, 0, 0, 0],
			// 心率相关
			heartBpm: 15,
			heartDatas: [],
			paintHeartDatas: [],
			paintHeartDatasCurrentIndex: 0,
			pointer: 0,
			HeartWave_Y_Mode: [0],
			T_cnt_present: 0,

			// 图表
			chart1: null,
			chart2: null,
		};
	},
	created() {
		// 白天：呼吸 12-20 心跳：55-100
		// 黑夜：呼吸 8-24  心跳：40-90

		// 1.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathYdataCopy.push(0);
		}

		// 2.获取用户信息
		this.role = this.$getCookie('userInfo').user.roleId;

		// 3.控制右侧监测仪是否为灰色
		if (this.detailPageData.status == 3 || this.detailPageData.status == 4) {
			this.isShowGray = 1;
		} else if (
			this.detailPageData.status == 1 ||
			this.detailPageData.subStatus == 1
		) {
			this.isShowGray = 2;
		}

		// 4.初始化已离床时间
		this.duration = '';

		// 5.模拟心率600个点位
		for (let i = 0; i < 600; i++) {
			this.heartXdata.push(0);
			this.heartYdataCopy.push(0);
		}

		// 6.模拟呼吸400个点位
		for (let i = 0; i < 400; i++) {
			this.breathXdata.push(0);
		}

		// 7.心率替换数组 - 固定 - 20个空字符串
		for (let i = 0; i < 20; i++) {
			this.replaceArr.push('');
		}

		// 8.判断是否已离床
		if (
			(this.detailPageData.status == 5 || this.detailPageData.status == 6) &&
			this.detailPageData.subStatus == 1
		) {
			this.monitorStatusStr = '已离床';
		}

		// 9.初始化是否显示图表
		this.showEchars = this.detailPageData.showEchars;

		// 10.获取床位信息
		this.getBedInfoById(this.detailPageData.bedId);
	},
	mounted() {
		let that = this;

		// 1.建立实时画线 Websocket
		this.getSocketStatus();

		// 2.建立实时床位状态 Websocket
		this.getSocketStatusEchars();

		// 3.倒计时 10s
		let interval = null;
		interval = setInterval(() => {
			if (this.num > 0) {
				this.num--;
			} else {
				this.num = 0;
				clearInterval(interval);
			}
		}, 1000);

		// 4.如果状态可用则停止倒计时器
		if (this.detailPageData.status === 1 && this.detailPageData.subStatus !== 1) {
			setTimeout(() => {

				// 4-1.显示图表
				this.showEchars = true;

				// 4-2.清理倒计时定时器
				clearInterval(interval);

				// 4-3.每秒绘制一次图
				this.drawInterval = setInterval(() => {
					this.beginDrawechars();
				}, 1000);

			}, 3000);

			setTimeout(() => {

				// 4-4.每秒创建一次心率数据
				this.changeHeartDataInterval = setInterval(() => {
					this.changeHeartArr();
				}, 1000);

			}, 1000);
		}

		// 5.浏览器监听切换事件
		document.addEventListener('visibilitychange', function () {
			if (document.visibilityState == 'hidden') {
				// 5-1.停止绘制
				that.stopDrawechars();
			} else {
				// 5-2.页面切换回来后再次开始绘制
				that.drawInterval = setInterval(() => {
					that.beginDrawechars();
				}, 1000);
			}
		});
	},
	methods: {
		// 开始绘制
		beginDrawechars() {
			this.drawBreathCharts();
			this.drawHeartCharts();
		},
		// 停止绘制
		stopDrawechars() {
			clearInterval(this.drawInterval);
			clearInterval(this.heartInterval);
			clearInterval(this.breathInterval);
		},
		// 绘制呼吸率图表
		drawBreathCharts() {
			if (!this.$refs.echartsForBreach) {
				return
			}
			let newYdata = this.changeBreathArr();
			this.breathYdata = [...this.breathYdata, ...newYdata];

			clearInterval(this.breathInterval);
			if (this.myChartBreath == null) {
				this.myChartBreath = this.$echarts.init(
					this.$refs.echartsForBreach,
					null,
					{
						devicePixelRatio: 2.5,
					}
				);
			}

			let option = getEchartOptionDetaliPageConRoom1(this.breathXdata, this.breathYdataCopy, this.isShowRedBreath === 2 ? '#1890FF' : '#FF4D4F');

			this.breathInterval = setInterval(() => {
				this.breathYdataCopy.splice(-1);
				this.breathYdataCopy.unshift(...this.breathYdata.splice(0, 1));
				option.series[0].data = this.breathYdataCopy;
				option.series[0].lineStyle.color =
					this.isShowRedBreath === 2 ? '#1890FF' : '#FF4D4F';
				this.myChartBreath.setOption(option);
			}, 100);

			//图表自适应
			window.addEventListener('resize', () => {
				if (this.myChartBreath) {
					this.myChartBreath.resize(); // myChart 是实例对象
				}
			});
		},
		// 绘制心率图表
		drawHeartCharts() {
			if (!this.$refs.echartsForHeart) {
				return
			}

			clearInterval(this.heartInterval);
			if (this.myChartHeart == null) {
				this.myChartHeart = this.$echarts.init(
					this.$refs.echartsForHeart,
					null,
					{
						devicePixelRatio: 2.5,
					}
				);
			}
			let flag = 0;
			let option = getEchartOptionDetaliPageConRoom2(this.heartXdata, this.heartYdataCopy, this.isShowRedHeart === 2 ? '#52C419' : '#FF4D4F');
			this.heartInterval = setInterval(() => {
				this.heartflag++;
				flag = this.heartflag;
				if (flag >= 600) {
					flag = 0;
					this.heartflag = 0;
				}
				let spliceData = this.heartAllLineData.splice(0, 1);
				this.heartYdataCopy.splice(flag, 20, ...this.replaceArr);
				this.heartYdataCopy.splice(flag, 1, spliceData[0]);
				option.series[0].data = this.heartYdataCopy;

				this.circlePosition = ((flag * 1) / 600) * 100 + '%';
				this.circleTopPosition = this.heartYdataCopy[flag - 1] + 110 + 'px';

				(option.series[0].lineStyle.color =
					this.isShowRedHeart === 2 ? '#52C419' : '#FF4D4F'),
					this.myChartHeart.setOption(option);
			}, 10);
			//图表自适应
			window.addEventListener('resize', function () {
				if (this.myChartHeart) {
					this.myChartHeart.resize(); // myChart 是实例对象
				}
			});
		},
		computedLeaveBed(value) {
			if (this.duration != '') {
				return
			}
			let falg = 0;
			if (this.leaveBedInterval) {
				clearInterval(this.leaveBedInterval);
			}
			if (value) {
				this.duration = this.formatSeconds(value + falg);
				this.leaveBedInterval = setInterval(() => {
					falg++;
					this.duration = this.formatSeconds(value + falg);
				}, 1000);
			}
		},
		// 开启实时画线 Websocket
		getSocketStatus() {
			// 1.默认已离床时间为空
			this.duration = '';
			
			// 2.Websocket开始连接
			let id = this.detailPageData.sn;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socketStatus = new WebSocket(wsUrl); // 路径
			this.stompClientStatus = Stomp.over(this.socketStatus);
			this.stompClientStatus.debug = null;
			let headers = {
				Authentication: this.getCookie('userInfo').token, // 获取token
			};
			this.stompClientStatus.connect(
				headers,
				(frame) => {
					this.stompClientStatus.subscribe(
						'/topic/bedRealTime.' + id,
						(greeting) => {
							
							// 1.推送收到的数据
							let socketData = JSON.parse(greeting.body);

							// 2.没看懂
							// clearInterval(this.CounterInterval);
							// this.Counter = 3;
							// this.CounterInterval = setInterval(() => {
							// 	if (this.Counter == 0) {
							// 		this.Counter = 3;
							// 		this.breathYdata.push(...detaliPageConRoomCommonData4);
							// 		this.heartYdata.push(...detaliPageConRoomCommonData1);
							// 	} else {
							// 		this.Counter--;
							// 	}
							// }, 1000);

							// 3.没看懂
							if (socketData.status === 1) {
								this.showEchars = true;
								if (this.isBeginDrawechars) {
									this.isBeginDrawechars = false;
									this.myChartBreath == null;
									this.myChartHeart == null;
									this.beginDrawechars();
									this.changeHeartDataInterval = setInterval(() => {
										this.changeHeartArr();
									}, 1000);
									this.drawInterval = setInterval(() => {
										this.beginDrawechars();
									}, 1000);
								}
							}

							// 4.bpm - 赋值
							if (socketData.breathBpm !== 0) {
								this.breathBPM = socketData.breathBpm || '--';
							} else {
								this.breathBPM = socketData.breathBpm;
							}
							if (socketData.breathBpm !== 0) {
								this.heartBPM = socketData.heartBpm || '--';
							} else {
								this.heartBPM = socketData.heartBpm;
							}

							// 5.圆点颜色
							if (socketData.heartBpm >= socketData.heartStatus[0] && socketData.heartBpm <= socketData.heartStatus[1]) {
								this.circleBackground = '#53c31b';
							} else {
								this.circleBackground = '#FF4D4F';
							}

							// 6.房间状态 - 赋值
							this.roomStatus = socketData.status;

							// 7.低中高
							this.computedBreathPosition(
								socketData.breathStatus,
								socketData.breathBpm
							);
							this.computedHeartPosition(
								socketData.heartStatus,
								socketData.heartBpm
							);

							// 8.获取设备当前状态的描述文案 | 末端渐变色
							this.getMonitorStatusStr(socketData);
							this.getEndColor(socketData.stableNum);

							// 9.
							if (socketData.status === 3 || socketData.status === 4) {
								this.isShowGray = 1;
								this.isBeginDrawechars = true;
								clearInterval(this.drawInterval);
								clearInterval(this.breathInterval);
								clearInterval(this.heartInterval);
							} else {
								this.isShowGray = 2;
								this.drawBreathCharts();
							}

							// 10.
							if (socketData.status === 2) {
								clearInterval(this.drawInterval);
								clearInterval(this.breathInterval);
								clearInterval(this.heartInterval);
								this.showEchars = false;
								this.isBeginDrawechars = true;
								this.isOutBed = this.isOutBed + 1;
								this.breathBPM = '--';
								this.isShowRedBreath = 2;
								this.heartBPM = '--';
								this.isShowRedHeart = 2;
								if (this.isOutBed >= 1) {
									this.computedLeaveBed(socketData.duration);
								} else {
									clearInterval(this.leaveBedInterval);
									this.duration = ''
								}
							} else {
								this.isOutBed = 0;
								clearInterval(this.leaveBedInterval);
								this.duration = ''
							}

							// 11.离床报警赋值
							this.detailPageData.hasAlarm = socketData.outBedAlarm;
						}
					);
				},
				(err) => {
					this.reconnect();
				}
			);
		},
		getSocketStatusEchars() {
			// 1.Websocket开始连接
			let id = this.detailPageData.bedId;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socketStatusEchars = new WebSocket(wsUrl); // 路径
			this.stompClientStatusEchars = Stomp.over(this.socketStatusEchars);
			this.stompClientStatusEchars.debug = null;
			let headers = {
				Authentication: this.$getCookie('userInfo').token, // 获取token
			};
			// 连接
			this.stompClientStatusEchars.connect(
				headers,
				(frame) => {
					this.stompClientStatusEchars.subscribe(
						'/topic/bedStatus.' + id,
						(greeting) => {
							
							// 1.推送收到的数据
							let socketData = JSON.parse(greeting.body);

							// 2.
							if (socketData.status === 3 || socketData.status === 4) {
								this.isShowGray = 1;
								this.showEchars = false;
								clearInterval(this.intervalPulsSecond);
							} else {
								this.isShowGray = 2;
								this.showEchars = true;
							}

							// 3.
							if (socketData.status === 2) {
								clearInterval(this.intervalPulsSecond);
								clearInterval(this.breathInterval);
								clearInterval(this.heartInterval);
							}

							// 4.
							if (socketData.status === 1) {
								setTimeout(() => {
									clearInterval(this.heartInterval);
									clearInterval(this.breathInterval);
									clearInterval(this.intervalPulsSecond);
									let length = this.breathYdataCopy.length;

									for (let i = 0; i < 400 - length; i++) {
										this.breathYdataCopy.push(0);
									}
									setTimeout(() => {
									}, 1000);
								}, 10000);
							}

							// 5.
							this.detailPageData.status = socketData.status;
							this.detailPageData.subStatus = socketData.subStatus;
							this.detailPageData.statusName = socketData.statusName;
						}
					);
				},
				(err) => {
					this.reconnectEchars();
				}
			);
		},
		changeBreathArr() {
			let newBreathBpm = this.breathBPM == '--' ? 15 : this.breathBPM;
			let BreathWave_f;
			let BreathWave_Ytemp = [];
			BreathWave_f = newBreathBpm / 60;
			for (let i = 0; i < 10; i++) {
				if (newBreathBpm == 0) {
					BreathWave_Ytemp.push(0);
				} else {
					BreathWave_Ytemp.push(
						5 * Math.cos(((2 * 3.14 * BreathWave_f) / 10) * (i + 1) + this.Phi)
					);
				}
			}
			this.Phi =
				(this.Phi + ((2 * 3.14 * BreathWave_f) / 10) * 11) % (2 * 3.14);
			return BreathWave_Ytemp;
		},
		changeHeartArr() {
			if (this.heartAllLineData.length > 600) {
				return;
			}
			let newHeartBpm = this.heartBPM == '--' ? 70 : this.heartBPM;
			let HeartWave_Y = [];
			if (newHeartBpm > 80) {
				newHeartBpm = 80;
			} else if (newHeartBpm < 65) {
				newHeartBpm = 65;
			}
			// let RR = (60 / newHeartBpm) * 1000 + (Math.random() - 0.5) * 600;
			let RR = (60 / newHeartBpm) * 1000;
			let T_cnt_new = Math.round((RR / 1000) * 100);
			let HeartWave_TP_cnt = T_cnt_new - this.HeartWave_QRSTPR_cnt;
			for (let i = 0; i < 100; i++) {
				this.pointer = this.pointer + 1;
				HeartWave_Y.push(this.HeartWave_Y_Mode[this.pointer - 1]);
				if (this.pointer >= this.T_cnt_present) {
					let zerosArr = [];
					for (let index = 0; index < HeartWave_TP_cnt; index++) {
						zerosArr.push(0);
					}
					this.HeartWave_Y_Mode = this.Buff_Electrocardiogram_QRST.concat(
						zerosArr,
						this.Buff_Electrocardiogram_PR
					);
					this.T_cnt_present = this.HeartWave_Y_Mode.length;
					this.pointer = 0;
				}
			}
			this.heartAllLineData.push(...HeartWave_Y);
		},
		// Websocket重连
		reconnect() {
			clearInterval(this.reconInv);
			this.reconInv = setTimeout(() => {
				this.getSocketStatus();
			}, 2000);
		},
		reconnectEchars() {
			clearInterval(this.reconInvEcahrs);
			this.reconInvEcahrs = setTimeout(() => {
				this.getSocketStatusEchars();
			}, 2000);
		},
		// 关闭 Websocket
		closeWebsocket() {
			if (this.stompClientStatus) {
				this.stompClientStatus.disconnect();
				this.socketStatus = null;
				this.stompClientStatus = null;
			}
			if (this.stompClientStatusEchars) {
				this.stompClientStatusEchars.disconnect();
				this.socketStatusEchars = null;
				this.socketStatusEchars = null;
			}
		},
		// 获取床位信息
		getBedInfoById(bedId) {
			let params = {
				bedId: bedId,
			};
			this.$get(
				'/api/v3/bed/getBedInfoById',
				params,
				(res) => {
					if (res.code === 0) {
						if (!res.data) {
							return;
						}
						this.switchStatus =
							res.data.monitorInfoVO.onOff === 0 ? false : true;
						this.bedSetId = res.data.bedId;
						this.radarId = res.data.radarId;
					}
				},
				(err) => {
					console.log(err);
				}
			);
		},
		// 设置监测仪状态
		setStatus() {
			this.num = 10;
			this.isTextarea = this.switchStatus ? false : true;
			let param = {
				bedId: this.detailPageData.bedId,
				onOff: this.switchStatus ? 1 : 0,
			};
			this.$put(
				'/api/monitor/onOff',
				param,
				(res) => {
					if (res.code == 0) {
						if (this.switchStatus == 1) {
							this.$message.success('监测仪已开启');
						} else {
							this.$message.success('监测仪已关闭');
						}
						this.$emit('getHistoryList');
						this.isShowGray = 1;
					}
				},
				(err) => { }
			);
		},
		// 卫生间停留时长取消
		editAbnormalTimeCancelOutBed() {
			this.editAbnormalTimePopupOutBed = false;
		},
		// 卫生间停留时长确定
		editAbnormalTimeToitet() {
			let len = this.relateWC_treeData_value_Sel_Next.length;
			let fallId = this.relateWC_treeData_value_Sel_Next[len - 1];
			let timePeriods = this.getFallLongTimeData.timePeriods
			let new_timePeriods = []
			if (timePeriods.length > 0) {
				for (let i = 0; i < timePeriods.length; i++) {
					let obj = {
						bedId: timePeriods[i].bedId,
						endTime: this.$dateTime(timePeriods[i].endTime._d).time.slice(0, 5),
						id: timePeriods[i].id,
						outBedAlarmTime: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
						startTime: this.$dateTime(timePeriods[i].startTime._d).time.slice(0, 5),
					}
					new_timePeriods.push(obj)
				}
			}
			let param = {
				radarId: this.radarId,
				fallId: fallId,
				outBedTimeout: this.$dateTime(this.editHandleTimeValOutBed._d).time + ':' + this.$dateTime(this.editHandleTimeValOutBed._d).seconds,
				timePeriods: new_timePeriods
			};
			this.$post(
				'/api/radar/radarFallAndSetOutTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');

						this.editAbnormalTimePopupOutBed = false;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 设置卫生间停留时长
		setToitet() {
			this.editAbnormalTimePopupOutBed = true;
			let param = {
				bedId: this.bedSetId,
			};
			this.$get(
				'/api/app/v1/getFallLongTime',
				param,
				(res) => {
					if (res.code == 0) {
						this.getFallLongTimeData = res.data
						this.OutBeddisabled = res.data.hasConsumer;
						this.editHandleTimeValOutBed = res.data.outBedTime ? this.$moment(res.data.outBedTime, 'HH:mm:ss') : '';

						let timePeriods = this.getFallLongTimeData.timePeriods
						if (timePeriods && timePeriods.length > 0) {
							for (let i = 0; i < timePeriods.length; i++) {
								timePeriods[i].startTime += ':00';
								timePeriods[i].startTime = this.$moment(timePeriods[i].startTime, 'HH:mm:ss');
								timePeriods[i].endTime += ':00';
								timePeriods[i].endTime = this.$moment(timePeriods[i].endTime, 'HH:mm:ss');
							}
						}
						this.getFallLongTimeData.timePeriods = timePeriods

					}
				},
				(err) => { }
			);
			this.getFallRelationTree();
			this.getFallRelation();
		},
		// 获取关联弹窗内树形结构
		getFallRelationTree() {
			this.$get(
				'/api/radar/getFallRelationTree',
				{},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData = res.data.children;
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 获取查看关联
		getFallRelation() {
			this.$get(
				'/api/radar/getFallRelation',
				{
					radarId: this.radarId,
				},
				(res) => {
					if (res.code == 0) {
						this.relateWC_treeData_value = res.data; //当前值 为进入查看时的值
						this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value; //选中前的值
						this.relateWC_treeData_value_Sel_Next = this.relateWC_treeData_value; //选中后的值
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击选择
		change_relateWC(value) {
			this.relateWC_treeData_value_Sel_Next = value; //赋值选中后的新值

			if (this.relateWcType == 1) {
				// 查看关联
				if (value.length < 1) {
					// 当前选中后为空,执行的叉子操作
					// 选中前的值等于默认的值
					if (
						this.relateWC_treeData_value_Sel_Prev ==
						this.relateWC_treeData_value
					) {
						this.del_relateWC_Tan = true; //二次确认弹窗
					}
				} else {
					//如果不为空，为赋值操作，选中后的值赋值给选中前的值
					this.relateWC_treeData_value_Sel_Prev = this.relateWC_treeData_value_Sel_Next;
				}
			} else if (this.relateWcType == 2) {
				// 关联卫生间
				console.log('关联卫生间无需操作');
			}
		},
		// 获取设备当前状态的描述文案
		getMonitorStatusStr(resData) {
			if (resData.status === 1) {
				this.monitorStatusStr = '真棒，实时监测中';
				if (!resData.isOffline) {
					this.monitorStatusStr = '监测仪离线';
				} else {
					if (!resData.isSignal) {
						this.monitorStatusStr = '信号似乎不太好哦';
					} else {
						if (resData.stableNum <= 59) {
							this.monitorStatusStr = '动作有点大哦，现在的呼吸率和心率不稳定，请尽量保持稳定';
						}
						if (resData.stableNum >= 60 && resData.stableNum <= 79) {
							this.monitorStatusStr = '您正在接近稳定噢，再努力一点点';
						}
						if (resData.stableNum >= 80) {
							this.monitorStatusStr = '真棒，实时监测中';
						}
						if (resData.tcfg === 1) {
							this.monitorStatusStr = '距离有点近哦，请调整与设备的距离';
						}
					}
				}
			} else if (resData.status === 2) {
				this.monitorStatusStr = '已离床';
			} else if (resData.status === 3) {
				this.monitorStatusStr = '监测仪离线';
			} else if (resData.status === 4) {
				this.monitorStatusStr = '监测关闭';
			} else if (resData.status === 5) {
				this.monitorStatusStr = '设备异常';
			}
		},
		// 获取渐变色结束颜色
		getEndColor(data) {
			this.stableNum = data;
			let colorArr = ['#CCA20F', '#BEA813', '#AEAE18', '#A2B520', '#95BB25', '#87BF29', '#7AC62E', '#6CC932', '#61CE36', '#65E332', '#65E332']
			let index = 0;
			if (data < 8) index = 0;
			if (data >= 8 && data < 16) index = 1;
			if (data >= 16 && data < 24) index = 2;
			if (data >= 24 && data < 32) index = 3;
			if (data >= 32 && data < 40) index = 4;
			if (data >= 40 && data < 48) index = 5;
			if (data >= 48 && data < 56) index = 6;
			if (data >= 56 && data < 64) index = 7;
			if (data >= 64 && data < 72) index = 8;
			if (data >= 72 && data < 80) index = 9;
			if (data >= 80) index = 10;
			this.endColor = colorArr[index];
		},
		computedBreathPosition(breathStatus, breathBpm) {
			let breathPositionStr = '';
			// 低
			if (breathBpm < breathStatus[0]) {
				this.isShowRedBreath = 1;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * breathBpm * 100 + '%';
			}
			// 中
			if (breathBpm >= breathStatus[0] && breathBpm <= breathStatus[1]) {
				this.isShowRedBreath = 2;
				breathPositionStr =
					(50 / 100 / (breathStatus[1] - breathStatus[0])) *
					(breathBpm - breathStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			// 高
			if (breathBpm > breathStatus[1]) {
				this.isShowRedBreath = 3;
				breathPositionStr =
					(25 / 100 / breathStatus[0]) * (breathBpm - breathStatus[1]) * 100 +
					65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (breathBpm >= 255) {
				this.isShowRedBreath = 2;
				this.breathBPM = '--';
			}
			this.breathPosition = breathPositionStr;
		},
		computedHeartPosition(heartStatus, heartBpm = 0) {
			let breathPositionStr = '';
			// 低
			if (heartBpm < heartStatus[0]) {
				this.isShowRedHeart = 1;
				breathPositionStr = (25 / 100 / heartStatus[0]) * heartBpm * 100 + '%';
			}
			// 中
			if (heartBpm >= heartStatus[0] && heartBpm <= heartStatus[1]) {
				this.isShowRedHeart = 2;
				breathPositionStr =
					(50 / 100 / (heartStatus[1] - heartStatus[0])) *
					(heartBpm - heartStatus[0]) *
					100 +
					25;
				if (breathPositionStr > 65) {
					breathPositionStr = 65;
				}
				breathPositionStr = breathPositionStr + '%';
			}

			// 高
			if (heartBpm > heartStatus[1]) {
				this.isShowRedHeart = 3;
				breathPositionStr =
					(25 / 100 / heartStatus[0]) * (heartBpm - heartStatus[1]) * 100 + 65;
				if (breathPositionStr > 90) {
					breathPositionStr = 90;
				}
				breathPositionStr = breathPositionStr + '%';
			}
			if (heartBpm >= 255) {
				this.isShowRedHeart = 2;
				this.heartBPM = '--';
			}
			this.heartPosition = breathPositionStr;
		},
		// 获取 cookie 信息
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		// 转时分秒
		formatSeconds(value) {
			let result = parseInt(value);
			let h =
				Math.floor(result / 3600) < 10
					? '0' + Math.floor(result / 3600)
					: Math.floor(result / 3600);
			let m =
				Math.floor((result / 60) % 60) < 10
					? '0' + Math.floor((result / 60) % 60)
					: Math.floor((result / 60) % 60);
			let s =
				Math.floor(result % 60) < 10
					? '0' + Math.floor(result % 60)
					: Math.floor(result % 60);

			let res = '';
			res += `${h}:${m}:${s}`;

			return res;
		},
	},
	beforeDestroy() {
		this.closeWebsocket();
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
@import '../detaliPage/detaliPageConRoomCss.css';
</style>
